import O1HD from "../../../../engines/gameEngine";
import NormalGameManager from "../../manager/NormalGameManager";
import { getBreedCooperativeMap } from "./cooperativeConst";
import CooperativeBreedItem from "./cooperativeBreedItem";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

@ccclass
export default class cooperativeBreedPage extends cc.Component {

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"item预制体"})
    itemPrefab:cc.Prefab = null;

    onLoad(){
        this.loadPage();
    }

    loadPage(){
        let dataAry = NormalGameManager._instance.getGameData().breedCooperativeData;
        for(let i of dataAry){
            let item:cc.Node = cc.instantiate(this.itemPrefab);
            let is = item.getComponent( CooperativeBreedItem );
            let data = getBreedCooperativeMap()[i];
            is.bindData(data,this.selectOne);
            item.setParent(this.itemContent);
        }
    }

    selectOne(node:cc.Node){
        let ns = node.getComponent( CooperativeBreedItem );
        let data = ns.data;
        let param = data.param;
        // 完善属性方法
        let hasBreedCooperativeData = NormalGameManager._instance.getGameData().hasBreedCooperativeData;
        if ( hasBreedCooperativeData && hasBreedCooperativeData.includes( data.id ) ) {
            O1HD.getModules().uiControlModule.showMessageBox("您已经拥有该证书了");
            return;
        }
        utilsModel.loadAndShowVideoAdTrans(()=>{
            if ( !hasBreedCooperativeData ) {
                hasBreedCooperativeData = [];
                NormalGameManager._instance.getGameData().hasBreedCooperativeData = hasBreedCooperativeData;
            }
            hasBreedCooperativeData.push( data.id );
            NormalGameManager._instance.writeGameData();
            O1HD.getModules().uiControlModule.showMessageBox("办理成功！");
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频错误");
        },()=>{

        },"办理养殖证书");
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
